<template>
  <question-group headline="Comprehension">
    <comprehension :models="blast.compResponses" :respondable="blast.isOpen" />
  </question-group>
</template>

<script>

  import sidebar from "./sidebar.js"

  export default {
    name: 'comp',
    mixins: [sidebar]
  }
</script>



// WEBPACK FOOTER //
// src/components/BlastStudent/sidebar/comp.vue